import { config ,getTotalDetails} from './config';
import '../../../styles/printStyle.css';
import IrdView from '../../common/irdReport/IrdView';
import withBaseState from '../../common/withBaseState';
import PropTypes from '../../../../node_modules/prop-types';
import { clone } from '../../../utils/arrayProcessor';
import * as queryService from '../../common/query.service';
import React, { Component } from '../../../../node_modules/react';
import { defaultHeaderConfig } from '../../common/irdReport/config';
import { NEW_SRN_VAT_REPORT_CONFIG } from '../../common/domain.config';
import VatReportStyle from './VatReportStyle';
import { getIrdSalesColumnTotals } from '../../../utils/handlers';
import {groupPrintDataSet} from "../../common/print.service";
import {onRowItemClick} from "../../fundamentals/common/helpers";

class NewSRNVatReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSet: [],
      display: {
        searchBox: false,
        filter: false,
      },
      printButtonClicked: false,
      queryParameters: { ...queryService.queryParameters },
      loading: false,
      columnTotal: {
        totalSales: 0,
        totalQuantity: 0,
        taxExemptedSales: 0,
        exportSales: 0,
        discount: 0,
        totalTaxableAmount: 0,
        vat: 0,
      },
      printData: {
        list: [],
        total: {},
      },
    };

    this.dataListLength = 0;
    const { downloadList } = this.props;
    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.loadTableData,
      downloadList,
    );
    this.basePaginationService.resetFilter();
  }

  /** adjust table width and height according to screen * */
  componentDidMount() {
    this.loadTableData();
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('contextmenu', this.handleMouseClick);
  }

  /** remove eventlistener on component unmount* */
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('contextmenu', this.handleMouseClick);
  }
  
  loadTableData = async(print=false) => {
    const self = this;
    const {getList } = this.props;
    const { queryParameters } = this.state;
    let query = clone(queryParameters);
    query.pagination.limit = 2000;
    await getList(print ? query:queryParameters)
      .then(response => {
        const nepaliDate = {
          start: response.nepali_date.start_date_nepali,
          end: response.nepali_date.end_date_nepali,
        };
        const columnTotal = getIrdSalesColumnTotals(response);
        const data = response.list;
        self.setState({
          dataSet: data,
          totalData: response.total,
          nepaliDate,
          columnTotal,
        }, () => print && this.groupPrintDataSetNew());
      })
      .catch(error => {
        console.error(error);
        this.sendErrorMessage();
      });
  };

  handlePrintClick = async() => {
    const self = this;
    await this.loadTableData(true);
    self.setState({ printButtonClicked: true }, () => {
      setTimeout(() => {
        window.print();
      }, 500);
    });
    window.onafterprint = function () {
      self.setState({ printButtonClicked: false });
    };
  };
  
  groupPrintDataSetNew() {
    const { dataSet  } = this.state;
    const {company} =this.props;
    const printInfoBill = {...company,printInfo:{...company.printInfo,batchEnabled:false}} || {};
    const orders = clone(dataSet);
    const dataList = groupPrintDataSet(orders, printInfoBill, config);
    this.setState({ dataList });
  }


  handleKeyDown = e => {
    const charCode = String.fromCharCode(e.which).toLowerCase();
    if ((e.ctrlKey && charCode === 'p') || (e.metaKey && charCode === 'p')) {
      e.preventDefault();
      this.handlePrintClick();
    }
  };

  handleMouseClick = e => {
    e.preventDefault();
    alert('Default menu stopped from poping up');
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;

    this.setState(display);
  };

  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  render() {
    const {
      dataSet,
      display,
      printButtonClicked,
      loading,
      queryParameters,
      totalData,
      columnTotal,
      dataList,
      nepaliDate,
      printData,
    } = this.state;
    const { company, serverResponseWaiting } = this.props;
    return (
      <VatReportStyle>
        <div className="new-sales-vat srn-vat-report upperTotalExist">
          <IrdView
            company={company}
            dataSet={dataSet}
            display={display}
            printList={dataList}
            tableConfig={{...config,header:{...config?.header,upperHeaderDetails:getTotalDetails(columnTotal)}}}
            totalData={totalData}
            nepaliDate={nepaliDate}
            columnTotal={columnTotal}
            printFlag={printButtonClicked}
            loading={serverResponseWaiting}
            queryParameters={queryParameters}
            printColumnTotal={printData.total}
            controlDisplay={this.controlDisplay}
            domainConfig={NEW_SRN_VAT_REPORT_CONFIG}
            handlePrintClick={this.handlePrintClick}
            handleDownloadClick={this.basePaginationService.handleDownloadClick}
            resetFilter={this.basePaginationService.resetFilter}
            headerConfig={{ ...defaultHeaderConfig, print: true }}
            handlePageSelect={this.basePaginationService.onPageSelect}
            handleTableSorting={this.basePaginationService.handleTableSorting}
            handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
            colSpan_t_l={9}
            colSpanTotal={3}
            printFooterEnable ={false}
            onTableBodyClick={onRowItemClick}
            enableTableFooter={false}
            disableUpperHeaderDetails={false}
            colSpan_t_l={1}
            colSpan_t_r={1}
          />
        </div>
      </VatReportStyle>
    );
  }
}

NewSRNVatReport.contextTypes = {
  router: PropTypes.object,
};

const CustomerWithState = withBaseState(NewSRNVatReport);

export default CustomerWithState;
